import React from 'react';
import './artist-preview.css';
import { useNavigate } from 'react-router-dom';

const ArtistPreview = ({artist}) => {
    const navigate = useNavigate();
    
    const handleClick = (id) => {
        navigate(`/artist/${id}`);
    };

    return (
        <div className='detail-container'
            onClick={() => handleClick(artist.id)}
        >
            <img className='portrait' src={`https://media.tracktribe.com/images/artists/${artist.image}`} alt='' />
            <div className='artist-preview-info-container'>
                <div className='artist-name'>{artist.artist_name.toUpperCase()}</div>
            </div>
        </div>
    )
}

export default ArtistPreview;